import { Button, Center, Heading, Icon, Spacer, VStack } from "@chakra-ui/react";
import { LucideRedo } from "lucide-react";

export function DefaultErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <Center minH="2xs">
      <VStack>
        <Heading as="h1" size="xs">
          An error occurred
        </Heading>
        <pre>{error.message}</pre>
        <Spacer />
        <Button onClick={resetErrorBoundary} leftIcon={<Icon as={LucideRedo} />}>
          Try again
        </Button>
      </VStack>
    </Center>
  );
}
